@if (label) {
  <label>
    {{ label }}
    @if (hint) {
      <span>{{ hint }}</span>
    }
  </label>
}
<nz-select
  #selectComponent
  [(ngModel)]="internalValue"
  [nzBorderless]="borderless"
  [nzDisabled]="disabled"
  [nzDropdownMatchSelectWidth]="true"
  [nzNotFoundContent]="' '"
  [nzOptionHeightPx]="40"
  [nzPlaceHolder]="placeholder | transloco"
  [nzShowSearch]="autocomplete"
  [style.width]="inputWidth"
  (ngModelChange)="onModelChange($event)"
  (nzBlur)="syncExternalTouched()"
  (nzOpenChange)="openChanged($event)">
  @for (option of transformedOptions; track option.value) {
    @if (option.type === 'option') {
      <nz-option
        nzCustomContent
        [nzDisabled]="option.disabled"
        [nzLabel]="option.label | transloco"
        [nzValue]="option.value">
        @if (selectOptionTemplateRef) {
          <ng-container
            [ngTemplateOutlet]="selectOptionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: option }">
          </ng-container>
        } @else {
          <span>{{ option.labelLong || option.label | transloco }}</span>
        }
      </nz-option>
    } @else if (option.type === 'auto') {
      <nz-option
        nzCustomContent
        [nzDisabled]="option.disabled"
        [nzLabel]="option.label | transloco"
        [nzValue]="option.value">
        @if (autoOptionTemplateRef) {
          <ng-container
            [ngTemplateOutlet]="autoOptionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: option }">
          </ng-container>
        }
      </nz-option>
    } @else {
      <nz-option-group [nzLabel]="option.label | transloco">
        @for (groupOption of option.groupChildren; track groupOption.value) {
          <nz-option
            nzCustomContent
            [nzDisabled]="option.disabled"
            [nzLabel]="groupOption.label | transloco"
            [nzValue]="groupOption.value">
            @if (selectOptionTemplateRef) {
              <ng-container
                [ngTemplateOutlet]="selectOptionTemplateRef"
                [ngTemplateOutletContext]="{ $implicit: groupOption }">
              </ng-container>
            } @else {
              <span>{{ option.labelLong || groupOption.label | transloco }}</span>
            }
          </nz-option>
        }
      </nz-option-group>
    }
  }
</nz-select>

@if (calculationInProgress) {
  <div
    class="projected-dropdown"
    #projectedDropdown>
    @for (option of transformedOptions; track option.value) {
      @if (selectOptionTemplateRef) {
        <ng-container
          [ngTemplateOutlet]="selectOptionTemplateRef"
          [ngTemplateOutletContext]="{ $implicit: option }">
        </ng-container>
      } @else {
        <span>{{ option.labelLong || option.label | transloco }}</span>
      }
      @if (!!option.groupChildren?.length) {
        @for (childOption of option.groupChildren; track childOption.value) {
          @if (selectOptionTemplateRef) {
            <ng-container
              [ngTemplateOutlet]="selectOptionTemplateRef"
              [ngTemplateOutletContext]="{ $implicit: childOption }">
            </ng-container>
          } @else {
            <span>{{ option.labelLong || childOption.label | transloco }}</span>
          }
        }
      }
    }
  </div>
}
